import { render, staticRenderFns } from "./DragDrop.vue?vue&type=template&id=30cdcded&scoped=true&"
import script from "./DragDrop.vue?vue&type=script&lang=js&"
export * from "./DragDrop.vue?vue&type=script&lang=js&"
import style0 from "./DragDrop.vue?vue&type=style&index=0&id=30cdcded&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30cdcded",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('30cdcded')) {
      api.createRecord('30cdcded', component.options)
    } else {
      api.reload('30cdcded', component.options)
    }
    module.hot.accept("./DragDrop.vue?vue&type=template&id=30cdcded&scoped=true&", function () {
      api.rerender('30cdcded', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pdf-renderer/exam/Question/DragDrop.vue"
export default component.exports